import React from 'react';
import {Alert, Center, Flex, Spinner} from '@chakra-ui/react';
import {User} from 'auth0';
import {CustomerSelector} from './CustomerSelector';
import {useMembership} from '../../hooks/api/customer';

export const Welcome = ({logout, user}: {logout: Function; user: User}) => {
  const membership = useMembership();

  if (membership.isError) {
    return (
      <Alert status="error">
        Something went wrong. Please contact support@keyplay.io
      </Alert>
    );
  }

  if (membership.isPending || !membership.data) {
    return (
      <Flex height="100vh" alignItems="center" justifyContent="center">
        <Spinner />
      </Flex>
    );
  }

  const customers = membership.data;
  if (!customers.length) {
    // This shouldn't happen since Auth0 should boostrap the user with a customer when
    // it detects they are not a member of any customers.
    return (
      <Center>
        <Alert status="error">
          You are not a member of any organizations. Please contact
          support@keyplay.io
        </Alert>
      </Center>
    );
  }

  return <CustomerSelector customers={customers} logout={logout} user={user} />;
};
